<div
  class="block mx-auto overflow-hidden md:px-6 md:py-6 lg:px-12 max-w-screen-4xl"
  [ngClass]="!displayCarousel && !heroContextualHeading ? 'h-screen md:py-0' : 'lg:h-screen'"
>
  <div class="relative flex flex-col w-full h-full">
    @if (displayNavigation) {
      <app-navigation-atom
        [navigationLogo]="navigationLogo?.url"
        [accentColor]="accentColor"
      ></app-navigation-atom>
    }
    <div class="relative flex min-h-[75vh] flex-1 items-center md:rounded-2xxl md:shadow-2xl">
      <div
        class="absolute inset-0"
        [ngClass]="
          !displayCarousel && !heroContextualHeading
            ? '[&>*]:md:rounded-2xxl'
            : '[&>*]:md:rounded-t-2xxl'
        "
      >
        <img
          [src]="heroImage?.url"
          class="object-cover w-full h-full"
        />
        <div class="absolute inset-0 bg-black/30"></div>
      </div>

      <div
        class="relative flex flex-col items-center justify-center w-full h-full gap-12 px-4 text-white max-h-max"
      >
        <div class="flex flex-col items-center justify-center gap-2 p-6">
          @if (heroLogo) {
            <img
              [src]="heroLogo?.url"
              class="w-auto h-full max-w-3/4 md:max-w-screen-sm xl:max-w-3/4"
            />
            @if (heroBaseline) {
              <p
                class="py-6 text-lg font-bold text-center"
                [style.color]="heroBaselineColor | contentBuilderColor"
              >
                {{ heroBaseline }}
              </p>
            }
          }
          @let settingParameters = settingsParameters$ | async;
          <div
            class="flex flex-row gap-2"
            role="tablist"
          >
            @if (availableDistributionModes$ | async; as availableDistributionModes) {
              @for (distributionMode of availableDistributionModes; track $index) {
                <button
                  role="tab"
                  tabindex="0"
                  [aria-selected]="distributionMode.value === settingParameters.distribution_mode"
                  [aria-controls]="'tab-content-' + $index"
                  [id]="'tab-' + $index"
                  class="flex flex-col items-center justify-center w-24 h-24 p-1 text-center bg-white shadow-xl cursor-pointer rounded-m"
                  (click)="openParametersModal(distributionMode.value)"
                  [style.color]="heroContextualHeadingColor | contentBuilderColor"
                >
                  <i class="icon {{ distributionMode.icon }} text-lg md:text-2xl"></i>
                  <p class="leading-tight bold text-10 md:text-sm">
                    {{ distributionMode.label | translate }}
                  </p>
                </button>
              }
            }
          </div>
        </div>
      </div>
    </div>
    @if (displayCarousel || heroContextualHeading) {
      <div class="p-8 bg-white md:rounded-b-2xxl lg:h-64 lg:max-h-64">
        <div
          class="grid items-start grid-cols-1 md:gap-6 lg:gap-12"
          [ngClass]="heroContextualHeading ? 'md:grid-cols-4' : 'grid-cols-1'"
        >
          @if (heroContextualHeading) {
            <div
              [style.color]="heroContextualHeadingColor | contentBuilderColor"
              class="md:col-span-2"
            >
              <h2 class="mb-4 text-3xl font-bold xl:text-5xl">
                {{ heroContextualHeading }}
              </h2>
              <p class="mb-6 text-sm md:line-clamp-3">
                {{ heroContextualContent }}
              </p>
            </div>
          }
          @if (cards) {
            <div
              class="lg:absolute lg:bottom-4"
              [ngClass]="
                heroContextualHeading
                  ? 'w-screen md:w-2-screen md:max-w-screen-lg left-2/4'
                  : 'w-screen'
              "
            >
              <app-hero-carousel-block
                [cards]="cards"
                [accentColor]="accentColor"
              ></app-hero-carousel-block>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
